import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import DynamicTable from '../DynamicTable';
import { TABLE_ALARM, TABLE_ALARM_LOG } from '../../Services/TableService';
import { tabsByPermission } from '.';
import TabComponent from '../TabComponent';
import { ITableFilter, setTableFilterAtom } from '../../store/recoil/TableState';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import PageHeader from '../PageHeader';

export default function AlarmLogs(): JSX.Element {
  const tableFilter = useRecoilValue<ITableFilter | null>(setTableFilterAtom);
  const tabs = React.useState(tabsByPermission([TABLE_ALARM, TABLE_ALARM_LOG], TABLE_ALARM_LOG))[0];
  const { formatMessage: f } = useIntl();
  const documentTitle = `${f({ id: 'tab.alarm/log' })} - ${f({ id: 'menu.alarms' })}`;
  useDocumentTitle(documentTitle);

  return (
    <>
      <PageHeader title={f({ id: 'menu.alarms' })} onlineHelpTopic="alarms" />
      <div className="pl-4 pr-4">
        <TabComponent tabs={tabs}>
          <div>
            <DynamicTable name={TABLE_ALARM_LOG} filter={tableFilter} mustClosed={true} />
          </div>
        </TabComponent>
      </div>
    </>
  );
}
